import script from "./Feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./Feedback.vue?vue&type=script&setup=true&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=4fc59538&lang=scss&scoped=true"
import "./Feedback.vue?vue&type=style&index=1&id=4fc59538&scoped=true&lang=css"
import "./Feedback.vue?vue&type=style&index=2&id=4fc59538&lang=css"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc59538"]])

export default __exports__